function Unlocked({ size }: { size: number }) {
	return (
		<svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.74963 9.00117V8.25124C8.7494 7.41987 9.02548 6.612 9.53445 5.95465C10.0434 5.29729 10.7564 4.82772 11.5614 4.61976C12.3663 4.41181 13.2175 4.47727 13.9812 4.80584C14.7449 5.13441 15.3777 5.70747 15.7802 6.43492L17.0918 5.70674C16.5281 4.68857 15.642 3.88661 14.5728 3.4269C13.5037 2.96719 12.3121 2.8758 11.1853 3.16711C10.0585 3.45841 9.06053 4.11589 8.34814 5.03619C7.63576 5.95649 7.24939 7.08743 7.24978 8.25124V9.00117H5V18.7502C5 19.3469 5.23703 19.9191 5.65895 20.3411C6.08086 20.763 6.6531 21 7.24978 21H17.7488C18.3454 21 18.9177 20.763 19.3396 20.3411C19.7615 19.9191 19.9985 19.3469 19.9985 18.7502V9.00117H8.74963ZM18.4987 18.7502C18.4987 18.9491 18.4197 19.1399 18.279 19.2805C18.1384 19.4211 17.9477 19.5001 17.7488 19.5001H7.24978C7.05089 19.5001 6.86014 19.4211 6.7195 19.2805C6.57886 19.1399 6.49985 18.9491 6.49985 18.7502V10.501H18.4987V18.7502Z"
				fill="#5B5B5B"
			/>
			<path d="M13.2489 13.501H11.749V16.5007H13.2489V13.501Z" fill="#5B5B5B" />
		</svg>
	);
}

export default Unlocked;
